import { render, staticRenderFns } from "./DoubleSlider.vue?vue&type=template&id=387bff31&scoped=true&"
import script from "./DoubleSlider.vue?vue&type=script&lang=js&"
export * from "./DoubleSlider.vue?vue&type=script&lang=js&"
import style0 from "./DoubleSlider.vue?vue&type=style&index=0&id=387bff31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387bff31",
  null
  
)

export default component.exports